module.exports = __webpack_public_path__ + "static/media/arrowDown.e206b035.svg";